import React from 'react'
import { Cube } from '../../geometries/Cube'
import { LeftPart } from './DoorParts/LeftPart'
import { degreesToRadians } from '../../helpers'

export const DoorLeft = ({ position = [0, 0, 0], rotation, scale = 1, color, height }) => {
	return (
		<group position={position} scale={[scale, scale, scale]} rotation={[0, (Math.PI / -2) - degreesToRadians(rotation), 0]} castShadow receiveShadow>
			<group position={[height / (2 * scale), 0, 0]} castShadow receiveShadow>
				<LeftPart color={color} />
				<Cube color={color} position={[0, 25, 15]} size={[5, 50, 5]} />
			</group>
		</group>
	)
}
